const topics = [
  { title: '热血战斗', desc: '燃爆全场的打斗场面', icon: 'ri-sword-line', count: '2.3万部', color: 'primary' },
  { title: '甜蜜恋爱', desc: '少女心爆棚的浪漫故事', icon: 'ri-heart-line', count: '1.8万部', color: 'accent' },
  { title: '悬疑推理', desc: '烧脑反转猜不到结局', icon: 'ri-lightbulb-line', count: '9800部', color: 'secondary' },
  { title: '搞笑日常', desc: '轻松解压笑到停不下来', icon: 'ri-emotion-laugh-line', count: '1.5万部', color: 'primary' },
  { title: '奇幻冒险', desc: '异世界冒险精彩纷呈', icon: 'ri-rocket-line', count: '2.1万部', color: 'accent' },
  { title: '古风仙侠', desc: '唯美国风修仙问道', icon: 'ri-moon-line', count: '1.6万部', color: 'secondary' },
  { title: '都市生活', desc: '现实题材引发共鸣', icon: 'ri-building-line', count: '1.2万部', color: 'primary' },
  { title: '科幻未来', desc: '未来世界无限想象', icon: 'ri-planet-line', count: '8600部', color: 'accent' },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-600', border: 'border-primary-200' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-600', border: 'border-accent-200' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-600', border: 'border-secondary-200' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-500">精选八大分类，总有一款适合你</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {topics.map((topic, idx) => {
            const c = colorMap[topic.color];
            return (
              <div
                key={idx}
                className={`${c.bg} border ${c.border} rounded-xl p-4 md:p-5 hover:scale-[1.02] transition-transform cursor-pointer`}
              >
                <div className={`w-10 h-10 rounded-lg ${c.bg} flex items-center justify-center mb-3`}>
                  <i className={`${topic.icon} ${c.text} text-lg`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">{topic.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{topic.desc}</p>
                <span className={`text-xs ${c.text} font-medium`}>{topic.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}